var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.85795 0H18.892C19.5014 0 20 0.471429 20 1.04762V13.619C20 14.1952 19.5014 14.6667 18.892 14.6667H16.6078V6.98413C16.6078 6.40794 16.1092 5.93651 15.4999 5.93651H3.75V1.04762C3.75 0.471429 4.24858 0 4.85795 0ZM1.07143 7.33333H13.9286C14.5203 7.33333 15 7.80237 15 8.38095V20.9524C15 21.531 14.5203 22 13.9286 22H1.07143C0.479695 22 0 21.531 0 20.9524V8.38095C0 7.80237 0.479695 7.33333 1.07143 7.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyMedium);
export default __webpack_public_path__ + "static/media/copy-medium.4b03fed3a79733922bcda0859059e5cf.svg";
export { ForwardRef as ReactComponent };